export default __webpack_public_path__ + "static/media/ghost-three-step_mobile.c7dbf53a.png";